import http from "../../plugins/axios";

export default {
    getSymbolList(data) {
        return http.get({
            url: '/la/admin/tenant/spotSymbol/spotSymbolList',
            data
        })
    },
    // 现货
    getSpotSymbolPage(data) {
        return http.get({
            url: `/la/admin/tenant/spotSymbol/getSpotSymbolPage`,
            data
        });
    },
    addSpotSymbol(data) {
        return http.post({
            url: `/la/admin/tenant/spotSymbol/addSpotSymbol`,
            data
        })
    },
    updateSpotSymbol(data) {
        return http.post({
            url: `/la/admin/tenant/spotSymbol/updateSpotSymbol`,
            data
        })
    },


};
